import React from 'react';
import Card from '../../components/ui/Card/Card';
import Skeleton from '../../components/ui/Skeleton/Skeleton';
import styles from './DeliveryForm.module.css';

const FieldSk = () => (
  <div className={styles.field}>
    <Skeleton width={90} height={12} />
    <Skeleton width="100%" height={40} className={styles.skRounded} />
  </div>
);

const DeliveryFormSkeleton: React.FC = () => (
  <div className={styles.page}>
    <Card>
      <Skeleton width={200} height={24} className={styles.skTitle} />
      <div className={styles.fieldsGrid}>
        {Array.from({ length: 10 }).map((_, i) => (
          <FieldSk key={i} />
        ))}
        <div className={styles.schedulesGroup}>
          <Skeleton width={130} height={14} />
          <div className={styles.schedulesRow} style={{ marginTop: 12 }}>
            <FieldSk />
            <FieldSk />
          </div>
        </div>
      </div>
      <div className={styles.checksGrid}>
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} width="70%" height={16} />
        ))}
      </div>
    </Card>

    <Card>
      <Skeleton width={180} height={24} className={styles.skTitle} />
      <div className={styles.grid4}>
        {Array.from({ length: 4 }).map((_, i) => (
          <FieldSk key={i} />
        ))}
      </div>
      <div className={styles.grid3}>
        {Array.from({ length: 3 }).map((_, i) => (
          <FieldSk key={i} />
        ))}
      </div>
      <div className={styles.grid2b}>
        <FieldSk />
        <FieldSk />
      </div>
      <div className={styles.actions}>
        <Skeleton width="100%" height={44} className={styles.skRounded} />
      </div>
    </Card>
  </div>
);

export default DeliveryFormSkeleton;
